import React from "react";

export default function CityWhyCallout({ cityName }) {
  return (
    <div className="bg-br-black text-white p-6 rounded">
      <div className="br-eyebrow text-br-bronze-2">Why {cityName} Homeowners Choose Black Ridge</div>
      <h3 className="font-display text-xl mt-2 tracking-widest uppercase">A Real GC. Real Communication. Real Follow-Through.</h3>
      <p className="mt-3 text-gray-300 text-sm">We handle roofing, remodeling, repairs, and ongoing maintenance under one team. You stop chasing five different contractors. We stay familiar with the property. Issues get solved faster.</p>
    </div>
  );
}
